import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors } from '@angular/forms';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../api.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../../app.constants';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StripeService, StripeCardComponent, Element as StripeElement, ElementOptions, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
//import { ChangePlanComponent } from './change-plan/change-plan.component'; 
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';

@Component({
    selector: 'app-subscription-purchase',
    templateUrl: './subscription-purchase.component.html'
})

export class SubscriptionPurchaseComponent implements OnInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    stripeKey = '';
    error: any;
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
    cardOptions: ElementOptions = {
        style: {
        base: {
            iconColor: '#276fd3',
            color: '#31325F',
            lineHeight: '40px',
            fontWeight: 300,
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSize: '18px',
            '::placeholder': {
            color: '#CFD7E0'
            }
        },
        invalid: {
            color: '#C12127',
            iconColor: '#C12127'
        }
        }
    };
    withinPR:boolean = false;
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    elementsOptions: ElementsOptions = {
        locale: localStorage.getItem('language')=='es'?'es':'en'
    };

    translateFunc:any;
    token:string;
    formSubmitted: boolean = false;
    cart:any;
    userId:any;
    tax:any;
    subtotal:any;
    total:any;
    MorY:any;
    disableBtn = false;
    orgProfile:any;
    email:any;
    modalOptions: NgbModalOptions = {};

    stripe;

    cardErrors;
    cardInfo:any;
  
    loading = false;
    confirmation;

    submitted = false;
    formProcess = false;
    message = "";

    constructor(private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        public router: Router, 
        private modalService: NgbModal,
        private translate: TranslateService,
        private _stripe: StripeService,
        private spinner: NgxSpinnerService){
            translate.setDefaultLang('en');
            this.translateFunc = functionsService;
        } 

    buySubscriptionForm = this.formBuilder.group({
        CardName: ['', [Validators.required, Validators.maxLength(26), Validators.pattern(AppConstants.cardNameRegex)]],
        BillingAddress: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        BillingCity: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingState: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCountry: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCycle: [],
    });

    customStripeForm = this.formBuilder.group({
        cardNumber: [],
        cvv: [],
        expMonth: [],
        expYear: []
    });

    ngOnInit(){
        this.translate.onLangChange.subscribe(() => {
            if(this.error){
                this.error["message"] = "";
            }
            this.elementsOptions = {
                locale: (localStorage.getItem('language')=='es')?'es':'en'
            };
        });
        this.userId = this.functionsService.getUserId();
        this.getCartItem();
        this.getPreferredCard();
        this.buySubscriptionForm.valueChanges 
            .subscribe(() => {
                 this.disableBtn = this.buySubscriptionForm.valid;
            });
    }
    
    getCartItem(){
        this.spinner.show();
        this.apiService.getCart().subscribe(
            data => {
                if(data!=null){
                    this.cart = data;
                    this.MorY = this.MorY?this.MorY:"monthly";
                    this.model = { options: this.MorY=="yearly"?'Y':'M' };
                    this.getBillingQuantity(this.model.options);
                    this.zipCheck(this.withinPR);
                }
                else { //Get organization/profile info
                    this.apiService.getOrganizationProfile().subscribe(
                        data => {
                            this.orgProfile = data;
                            this.email = this.functionsService.getEmail();
                        }
                    );
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        )
    }

    getPreferredCard(){
        this.apiService.getPreferredCardFull().subscribe(
            data => {
                if(data!=null){
                    switch(data["cardType"]){
                        case "Visa":
                            data["card-fa"] = "fa fa-cc-visa";
                            break;
                        case "MasterCard":
                            data["card-fa"] = "fa fa-cc-mastercard";
                            break;
                        case "Discover":
                            data["card-fa"] = "fa fa-cc-discover";
                            break;
                        case "American Express":
                            data["card-fa"] = "fa fa-cc-amex";
                            break;
                        case "JCB":
                            data["card-fa"] = "fa fa-cc-jcb";
                            break;
                        default:
                            data["card-fa"] = "fa fa-credit-card";
                    }
                    this.cardInfo = data;
                    this.withinPR = this.functionsService.checkZipCode(+this.cardInfo.billingZipCode);
                    this.zipCheck(this.withinPR);
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    buySubscription(){
        document.getElementById("server_error").hidden = true;
        this.spinner.show();
        if(this.cardInfo==null){
            if (!this.buySubscriptionForm.valid) {
                Object.keys(this.buySubscriptionForm.controls).forEach(key => {
                const controlErrors: ValidationErrors = this.buySubscriptionForm.get(key).errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                    });
                }
                });
                this.formSubmitted = true;
                return;
            }
            this._stripe.createToken(this.card.getCard(), { 
                name: this.buySubscriptionForm.value["CardName"], 
                address_line1: this.buySubscriptionForm.value["BillingAddress"],
                address_city: this.buySubscriptionForm.value["BillingCity"],
                address_state: this.buySubscriptionForm.value["BillingState"],
                address_country: this.buySubscriptionForm.value["BillingCountry"],
                //address_zip: this.buySubscriptionForm.value["BillingZipCode"],
                currency: "USD"
            })
            .subscribe(result => {
                if (result.token)
                {
                    //Create body content
                    var content:Object = {};
                    content["Tax1"] = this.withinPR?this.tax:0;
                    content["Price"] = this.subtotal;
                    content["Total"] = this.total;
                    content["Result"] = result.token;
                    content["PlanId"] = this.cart.planId;
                    content["Cycle"] = this.buySubscriptionForm.value["BillingCycle"];
                    this.processPayment(content);
                } else if (result.error) {
                    // Error creating the token
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                    modalRef.componentInstance.message = result.error.message;
                    this.spinner.hide();
                }
            });
        } else{
            //Send existing cardinfo to process payment
            this.cardInfo.chosenPlan = this.cart.planId;
            this.cardInfo.tax1 = this.withinPR?this.tax:0;
            this.cardInfo.price = this.subtotal;
            this.cardInfo.total = this.total;
            this.cardInfo.cycle = this.buySubscriptionForm.value["BillingCycle"];
            this.apiService.processExistingPayment(this.cardInfo).subscribe(
                () => {
                    this.spinner.hide(); 
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                    modalRef.componentInstance.message = this.translate.instant('account.payment_processed');
                    this.translate.onLangChange.subscribe(() => {
                        modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                        modalRef.componentInstance.message = this.translate.instant('account.payment_processed');
                    });
                    modalRef.result.then(() => {
                        this.functionsService.userSignOut();
                    });
                }, 
                error => {
                    if(error["error"]["content"] && error["status"]==400){
                        var exceptionError = error["error"]["content"].split(':');
                        var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                        var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                        document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                        document.getElementById("server_error").hidden = false;
                        this.translate.onLangChange.subscribe(() => {
                            if(error["error"]["content"] && error["status"]==400){
                                var exceptionError = error["error"]["content"].split(':');
                                var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                                var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                                document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                                document.getElementById("server_error").hidden = false;
                            }
                        });
                    }else{
                        this.functionsService.errorHandler(error["status"]);
                    }
                    this.spinner.hide();
                }
            );
        }
    }

    processPayment(content){
        document.getElementById("server_error").hidden = true;
        this.apiService.processNewPayment(content).subscribe(
            () => {
                this.spinner.hide();
                const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                modalRef.componentInstance.message = this.translate.instant('account.payment_processed');
                this.translate.onLangChange.subscribe(() => {
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                    modalRef.componentInstance.message = this.translate.instant('account.payment_processed');
                });
                this.apiService.getAgentDispatch().subscribe(result => {
                    localStorage.setItem('agentDispatch', result['agentDispatch']);
                    localStorage.setItem('geoAssignment', result['geoAssignment']);
                });
                modalRef.result.then(() => {
                    this.functionsService.userSignOut();
                });
            }, 
            error => {
                if(error["error"]["content"] && error["status"]==400){
                    var exceptionError = error["error"]["content"].split(':');
                    var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                    var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                    document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                    document.getElementById("server_error").hidden = false;
                    this.translate.onLangChange.subscribe(() => {
                        if(error["error"]["content"] && error["status"]==400){
                            var exceptionError = error["error"]["content"].split(':');
                            var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                            var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                            document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                            document.getElementById("server_error").hidden = false;
                        }
                    });
                }else{
                    this.functionsService.errorHandler(error["status"]);
                }
                this.spinner.hide(); 
            }
        )
    }

    changePlan() {
        //Get list of available plans
        this.apiService.getPlans().subscribe(
            data => {
                //Pass current selected plan (if any)
                /*const modalRef = this.modalService.open(ChangePlanComponent, { size: 'xl' });
                if(this.cart == undefined){
                    modalRef.componentInstance.selectedPlan = 0;
                }
                else{
                    modalRef.componentInstance.selectedPlan = this.cart.planId;
                }
                modalRef.componentInstance.plans = data;
                modalRef.result.then(() => {
                    this.getCartItem();
                });*/
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getBillingQuantity(type){
        if(type=='Y'){
            this.subtotal = this.cart.planAnnualPrice;
            this.tax = (this.cart.planAnnualPrice * 11.5) / 100;
            this.total = this.withinPR?(this.subtotal + this.tax):this.subtotal;
            this.MorY = "yearly"
        }else{ //Montly is the default
            this.subtotal = this.cart.planMonthlyPrice;
            this.tax = (this.cart.planMonthlyPrice * 11.5) / 100;
            this.total = this.withinPR?(this.subtotal + this.tax):this.subtotal;
            this.MorY = "monthly"
        }
    }

    get CardName() { return this.controlGetter('CardName'); }
    get BillingAddress() { return this.controlGetter('BillingAddress'); }
    get BillingCity() { return this.controlGetter('BillingCity'); }
    get BillingState() { return this.controlGetter('BillingState'); }
    get BillingCountry() { return this.controlGetter('BillingCountry'); }
    get BillingCycle() { return this.controlGetter('BillingCycle'); }

    controlGetter(controlName) {
        const control =  this.buySubscriptionForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    cardUpdated(result) {
        var zipCode = +result.card.value.postalCode;
        this.withinPR = this.functionsService.checkZipCode(zipCode);
        this.zipCheck(this.withinPR);
        this
        this.element = result.element;
        this.complete = result.card.complete;
        this.error = undefined;
    }
    
    keyUpdated() {
        this._stripe.changeKey(this.stripeKey);
    }

    zipCheck(withinPR){
        if(withinPR){ //Show tax
            this.total = this.subtotal + this.tax;
            if(document.getElementById("tax-row")){document.getElementById("tax-row").style.display = 'flex';}
        }
        else{
            this.total = this.subtotal;
            if(document.getElementById("tax-row")){document.getElementById("tax-row").style.display = 'none';}
        }
    }
}